import React, { Component } from "react";
import { connect } from "react-redux";
import Drawer from "@mui/material/Drawer";
import "./Sidebar.css";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.apiClass = props.apiClass;
  }
  toggleSidebar = async (VisibilityValue) => {
    this.props.postUserSettingsGlobalSidebarVisible(VisibilityValue);
    let CustomData = {
      ...this.props.getUserSettingsGlobal,
      Sidebar: {
        Available: this.props.getUserSettingsGlobalSidebarAvailable,
        Visible: !this.props.getUserSettingsGlobalSidebarVisible
      }
    };
    await this.apiClass.PostUserSettings("global", CustomData);
  };
  render() {
    return (
      <Drawer
        variant="persistent"
        anchor="left"
        open={this.props.getUserSettingsGlobalSidebarAvailable}
        className={
          "drawer " +
          (!this.props.getUserSettingsGlobalSidebarVisible && "hide")
        }
        classes={{
          paper: "drawerPaper"
        }}
        PaperProps={{
          id: "SidebarLeft",
          style: {
            width: this.props.getUserSettingsGlobalSidebarVisible ? 300 : 39,
            overflow: "initial",
            marginTop: "90px",
            paddingTop: "10px",
            boxShadow: "0 0 21px 0 rgba(219, 219, 219, 0.5)",
            backgroundColor: "#ffffff",
            border: "none",
            zIndex: 1,
            height: "calc(100vh - 92px )"
          }
        }}
      >
        {this.props.getUserSettingsGlobalSidebarVisible ? (
          <>
            {typeof this.props.componentone === "function" &&
              this.props.componentone()}
            {typeof this.props.componenttwo === "function" &&
              this.props.componenttwo()}
            {typeof this.props.componentthree === "function" &&
              this.props.componentthree()}
            <KeyboardArrowLeftIcon
              onClick={() => {
                this.toggleSidebar(false);
              }}
              id="SidebarArrowLeft"
            />
          </>
        ) : (
          <KeyboardArrowRightIcon
            onClick={() => {
              this.toggleSidebar(true);
            }}
            id="SidebarArrowRight"
          />
        )}
      </Drawer>
    );
  }
}

function mapStateToProps(state) {
  return {
    getUserSettingsGlobalSidebarAvailable:
      state.User.Settings.Global.Sidebar.Available,
    getUserSettingsGlobalSidebarVisible:
      state.User.Settings.Global.Sidebar.Visible,
    getUserSettingsGlobal: state.User.Settings.Global
  };
}
const mapDispatchToProps = (dispatch) => {
  return {
    postUserSettingsGlobalSidebarVisible: (VisibilityValue) =>
      dispatch({
        type: "USER_SETTINGS_GLOBAL_SIDEBAR_VISIBLE",
        VisibilityValue
      })
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
